module.exports = "https://99designs-start-assets.imgix.net/js/c3792f55f55ae34d8b1a3825dc5c19e8.png";